import { render, staticRenderFns } from "./RoleAdd.form.vue?vue&type=template&id=351e8326&"
import script from "./RoleAdd.form.vue?vue&type=script&lang=js&"
export * from "./RoleAdd.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports